export default "__VITE_ASSET__P9kkI4sy__"